import { Component, Inject, NgZone, OnInit, Optional } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PershingTranslationService } from '@pershing/pershing-core';
import { MarketAlertsAgreementComponent } from '../MarketAlertsAgreement/market-alerts-agreement.component';

@Component({
  selector: 'market-alerts-wrapper',
  templateUrl: './market-alerts-wrapper.component.html'
})
export class MarketAlertsWrapperComponent implements OnInit {
  isAdvisor: boolean = false;
  isModernTheme: boolean = false;
  alertsSigned: boolean = false;
  dialogRef: any;
  isErrorOccured:boolean = false;


  constructor(
    private ngZone: NgZone,
    private translationService: PershingTranslationService,
    @Optional() @Inject('AppSettings') appSettings: any,
    public matDialog: MatDialog
  ) {

    this.translationService.addTranslationFolder('@pershing/nxi-ng-mod', 'node_modules/@pershing/nxi-ng-mod/lib');

    this.isModernTheme = appSettings.isModernTheme;
    this.isAdvisor = appSettings.isAdvisor;

    this.checkIsAgreementSigned();
    if(!this.alertsSigned) {
      this.loadMarketAlerts();
    }
  }

  ngOnInit() {
  }


  loadMarketAlerts() {
    console.log('MOD PAGE DATA');
    if (this.isModernTheme) {
      this.dialogRef = this.matDialog.open(MarketAlertsAgreementComponent,
        {
          panelClass: ['alrt-MarketAlerts_Dialog'],
          data: { data: 'data', status: 'yes', isAdvisor: this.isAdvisor },
          disableClose: true
        });
      this.dialogRef.afterClosed().subscribe((res) =>{
        if(res && res.isErrorOccured) {
          this.isErrorOccured=true;
        }
        this.dialogRef = null;
      })
    }
  }

  gotoSecurityAlert() {
    document.dispatchEvent(new CustomEvent('portal.gotoview', {
      detail: { gotoPage: '/nxi/research/investtools/marketalerts/securitiesalerts' }
    }));

  }

  checkIsAgreementSigned() {
    console.log('Checking f2container value ' + window['NXIF2Container']?.alertsSigned);
    this.alertsSigned = window['NXIF2Container']?.alertsSigned;
    console.log('Checking Alert is signed or not ' + this.alertsSigned);
  }

}
